import { ErrorBoundary } from '@monorepo/shared/componentsV2/ErrorBoundary';
import { AnalyticsSyncWizardStep } from '@monorepo/shared/componentsV2/fullPageWizard/AnalyticsSyncWizardStep/AnalyticsSyncWizardStep';
import { Page } from '@monorepo/shared/componentsV2/fullPageWizard/styled/fullPageWizard';
import { Loading } from '@monorepo/shared/componentsV2/Loading';
import { useDisableSubnav } from '@monorepo/shared/hooks/subnav/useDisableSubnav';
import { useWorkflow } from '@monorepo/shared/hooks/workflows/useWorkflow';
import { contentPaddingValue } from '@monorepo/shared/styles/layout';
import React from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { EditWorkflowHeader } from './EditWorkflowHeader';
import { WorkflowIncompleteDataMessages } from './shared/WorkflowIncompleteDataMessages';
import { WizardStep } from './types';

const StyledWorkflowIncompleteDataMessages = styled(
  WorkflowIncompleteDataMessages,
)`
  flex-shrink: 0;
  margin: ${contentPaddingValue} ${contentPaddingValue} 0;
`;

export function WorkflowAnalyticsSyncPage() {
  useDisableSubnav();

  const { organizationId, workflowId } = useParams();
  if (!organizationId || !workflowId) {
    throw new Error(
      'WorkflowAnalyticsSyncPage was rendered in a context without organization or/and Workflow id',
    );
  }

  const { workflow, isLoading: isWorkflowLoading } = useWorkflow({
    organizationId,
    workflowId,
  });

  if (isWorkflowLoading) {
    return (
      <Page>
        <EditWorkflowHeader wizardStep={WizardStep.ANALYTICS_SYNC} />
        <Loading />
      </Page>
    );
  }

  if (!workflow) {
    throw new Error("Couldn't get information about this Workflow.");
  }

  return (
    <Page>
      <EditWorkflowHeader wizardStep={WizardStep.ANALYTICS_SYNC} />
      <StyledWorkflowIncompleteDataMessages workflow={workflow} />
      <ErrorBoundary>
        <AnalyticsSyncWizardStep
          datasetId={workflow.outputDataset.id}
          datasetOriginLabel="Workflow"
          organizationId={organizationId}
        />
      </ErrorBoundary>
    </Page>
  );
}
